import { render, staticRenderFns } from "./DeletarSubMenu.vue?vue&type=template&id=2ab07d2b"
import script from "./DeletarSubMenu.vue?vue&type=script&lang=js"
export * from "./DeletarSubMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports